import React, { Fragment } from 'react';
import { Text, Stack, Divider } from '@moda/om';
import { OrderItem, Return } from '../../../hooks/useReturn';
import { Box } from '../../Box';
import { AccountOrderItem } from '../../OrderItem/AccountOrderItem';
import { AccountOrderHeader } from '../../AccountOrderHeader';
import { useOrder } from '../../../hooks/useOrder';
import { OrderDetailsShippingStatus } from '../../OrderDetailsMain/OrderDetailsItemsSections/OrderDetailsShippingStatus';

import './AccountReturnOrder.scss';

interface Props {
  items: OrderItem[] | undefined;
  returnOrder: Return;
}

export const AccountReturnOrder: React.FC<Props> = ({ items, returnOrder }) => {
  const { order } = useOrder(returnOrder.attributes.orderNumber);

  if (!order) return null;

  return (
    <Box className="AccountReturnOrder">
      <AccountOrderHeader
        order={order}
        showShipping={false}
        showRemainingBalance={false}
        showOrderTotal={false}
        showPayRemainingBalance={false}
        categoryName="returned"
      />

      <Stack space={2} className="AccountReturnOrder__body">
        {items?.map((item, index) => (
          <Fragment key={item.id}>
            <Stack space={2}>
              <div className="AccountReturnOrder__item">
                <AccountOrderItem item={item} showShippingStatus={false} order={order} />

                <Stack space={1}>
                  <Text treatment="body2" color="cement">
                    Status:
                  </Text>

                  <Text className="AccountReturnOrder__status" treatment="body2">
                    {item.attributes.status.replace(/_/g, ' ')}
                  </Text>
                </Stack>
                <OrderDetailsShippingStatus shippingStatus={item.attributes.shippingStatus} />
              </div>

              {index < items.length - 1 && <Divider />}
            </Stack>
          </Fragment>
        ))}
      </Stack>
    </Box>
  );
};
